<template>
	<div class="conteneur">
		<iframe :src='urlRadar' id="my_iframe">
		</iframe>
	</div>

</template>
<script>
	export default {
		computed: {
			urlRadar:() => process.env.VUE_APP_RADAR_URL
		},
		mounted () {
			this.resizeCrossDomainIframe('my_iframe', process.env.VUE_APP_TARGET_ORIGIN)
		},
		methods: {
			resizeCrossDomainIframe (id, other_domain) {
				var iframe = document.getElementById(id);
				window.addEventListener('message', function (event) {
					var domainesAutorises = other_domain.split(',')
					if (domainesAutorises.includes(event.origin) == false) { 
						return; // only accept messages from the specified domain
					}
					if (isNaN(event.data.width) && isNaN(event.data.height)) {
						return; // only accept something which can be parsed as a number
					}
					const width = parseInt(event.data.width); // add some extra height to avoid scrollbar
					const height = parseInt(event.data.height) + 32; // add some extra height to avoid scrollbar
					iframe.height = height + "px";
					iframe.width = width + "%";
				}, false);
			}
		}
	}
</script>

<style>
	.conteneur iframe {
		Position: absolute;
		border: none;
		top: 0;
		Left: 0;
		width: 100%;
		height: 100%;
	}

	iframe:focus {
		outline: none;
	}

	iframe[seamless] {
		display: block;
	}
</style>